import React, { useState, useEffect } from "react";
import BaseForm from "../../app/components/BaseForm";
import Input from "../../app/components/Input";
import Select from "../../app/components/Select";
import SelectResponsible from "../../app/components/SelectResponsible";
import { FiPhone, FiMail, FiUser, FiMonitor } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";

const EditRelevantRecord = ({ isOpen, onClose, title, selectedRecord, onSubmit }) => {
  const [formData, setFormData] = useState({
    enterprise: '',
    department: '',
    responsible: '',
    channel: '',
    record: '',
  });

  const departmentOptions = [
    { value: 'fiscal', label: 'Departamento Fiscal' },
    { value: 'pessoal', label: 'Departamento Pessoal' },
    { value: 'legal', label: 'Departamento Legal' },
    { value: 'contabil', label: 'Departamento Contábil' },
    { value: 'sucesso', label: 'Departamento Sucesso' },
    { value: 'financeiro', label: 'Departamento Financeiro' },
    { value: 'marketing', label: 'Departamento Marketing' },
    { value: 'vendas', label: 'Departamento Vendas' },
  ];

  const subjectOptions = [
    { value: 'fiscal', label: 'Departamento Fiscal' },
    { value: 'pessoal', label: 'Departamento Pessoal' },
    { value: 'legal', label: 'Departamento Legal' },
    { value: 'contabil', label: 'Departamento Contábil' },
    { value: 'sucesso', label: 'Departamento Sucesso' },
    { value: 'financeiro', label: 'Departamento Financeiro' },
    { value: 'marketing', label: 'Departamento Marketing' },
    { value: 'vendas', label: 'Departamento Vendas' },
  ];

  const responsibleOptions = [
    { value: 'paulo', label: 'Paulo' },
    { value: 'felipe', label: 'Felipe' },
    { value: 'jose_roberto', label: 'José Roberto' },
    { value: 'milena', label: 'Milena' },
  ];

  useEffect(() => {
    if (selectedRecord) {
      setFormData({
        id: selectedRecord.id || null,
        enterprise: selectedRecord.enterprise || '',
        department: selectedRecord.department || '',
        responsible: selectedRecord.responsible || '',
        channel: selectedRecord.channel || '',
        record: selectedRecord.record || '',
      });
    } else {
      setFormData({
        enterprise: '',
        department: '',
        responsible: '',
        channel: '',
        record: '',
      });
    }
  }, [selectedRecord]);


  const handleChange = (eOrValue, fieldName) => {
    if (fieldName === "responsible") {
      setFormData(prev => ({
        ...prev,
        responsible: eOrValue
      }));
      return;
    }

    if (eOrValue && typeof eOrValue === 'object' && 'value' in eOrValue && fieldName) {
      setFormData(prev => ({
        ...prev,
        [fieldName]: eOrValue.value
      }));
      return;
    }

    if (eOrValue && eOrValue.target) {
      const { name, value } = eOrValue.target;
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit && typeof onSubmit === "function") {
      onSubmit(formData);
    }
  };

  const renderFormFields = () => (
    <div>
      <h2 className="font-medium text-gray-700 mb-2">Canal</h2>
      <div className="grid grid-cols-2 ml-4 mb-8 gap-y-2">
        {[
          { id: 'callInput', label: 'Telefone', icon: <FiPhone size={14} />, value: 'Telefone' },
          { id: 'emailInput', label: 'Email', icon: <FiMail size={14} />, value: 'E-mail' },
          { id: 'whatsappInput', label: 'WhatsApp', icon: <FaWhatsapp size={14} />, value: 'WhatsApp' },
          { id: 'inPersonInput', label: 'Presencial', icon: <FiUser size={14} />, value: 'Presencial' },
          { id: 'onlineInput', label: 'Online', icon: <FiMonitor size={14} />, value: 'Online' },
        ].map((option) => (
          <div key={option.id} className="flex items-center gap-1">
            <input
              type="radio"
              id={option.id}
              name="channel"
              value={option.value}
              checked={formData.channel === option.value}
              onChange={handleChange}
              className="appearance-none w-4 h-4 border-2 border-[#672c71] cursor-pointer rounded-full relative flex items-center justify-center bg-white checked:bg-white before:content-[''] before:w-2 before:h-2 before:rounded-full before:bg-[#672c71] before:scale-0 before:transition-transform checked:before:scale-100"
            />
            <label htmlFor={option.id} className="flex items-center cursor-pointer text-gray-700 gap-1">
              {option.icon}
              <p>{option.label}</p>
            </label>
          </div>
        ))}
      </div>

      <div className="pb-4">
        <SelectResponsible
          label="Responsável"
          placeholder="Selecione o Responsável"
          name="responsible"
          options={responsibleOptions}
          value={formData.responsible}
          onChange={(value) => handleChange(value, "responsible")}
        />
      </div>

      <div className="pb-4">
        <Select
          label="Departamento"
          placeholder="Selecione o departamento"
          name="department"
          options={departmentOptions}
          value={formData.department}
          onChange={(value) => handleChange(value, "department")}
        />
      </div>

      <div className="pb-4">
        <Select
          label="Assunto"
          placeholder="Selecione o Assunto"
          name="subject"
          options={subjectOptions}
          value={formData.subject}
          onChange={(value) => handleChange(value, "department")}
        />
      </div>

      <div className="pb-4">
        <Input
          label="Comentários"
          name="record"
          placeholder="Descreva o registro relevante..."
          value={formData.record}
          onChange={handleChange}
          type="textarea"
        />
      </div>
    </div>
  );

  return (
    <BaseForm
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      title={title}
    >
      {renderFormFields()}
    </BaseForm>
  );
};

export default EditRelevantRecord;
